/**
 * Enums
 */
export enum DocumentType {
  Script = "Script",
  Storyboard = "Storyboard",
  ShootingSchedule = "Shoot Schedule",
  MediaPlan = "Media Plan",
  Contract = "Contract",
  License = "License",
  Generic = "Generic",
}
